import Reveal from "@/components/Reveal";
import { MEMORIES, PREVIOUS } from "@/data/site";

export default function Memories() {
  return (
    <div data-testid="memories-page">
      <section className="parchment border-b border-[color:var(--accent)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <Reveal>
            <div className="eyebrow mb-6">Memorable Moments · Previously Owned</div>
            <h1 className="font-display text-6xl md:text-8xl tracking-tighter leading-[0.95]">
              Stories worth <span className="italic text-[color:var(--brg)]">remembering.</span>
            </h1>
          </Reveal>
          <Reveal delay={120}>
            <p className="mt-10 text-lg md:text-xl text-[color:var(--ink-secondary)] max-w-3xl">
              Photoshoots, awards, costumes, weddings, breakdowns, and the cars that came before — the memories that make the collection feel alive.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Memorable masonry */}
      <section className="bg-[color:var(--surface)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <Reveal>
            <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
              <h2 className="font-display text-4xl md:text-5xl tracking-tight">Memorable Moments</h2>
              <span className="text-sm text-[color:var(--ink-muted)]">{MEMORIES.length} entries</span>
            </div>
          </Reveal>
          <div className="columns-1 md:columns-2 lg:columns-3 gap-6 [&>*]:mb-6">
            {MEMORIES.map((m, idx) => (
              <Reveal key={`mem-${idx}`} delay={(idx % 3) * 80}>
                <a
                  href={m.img}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`memory-${idx}`}
                  className="block group break-inside-avoid"
                >
                  <div className="tile">
                    <img
                      src={m.thumb || m.img}
                      alt={m.caption}
                      className="w-full h-auto object-cover block"
                      loading="lazy"
                    />
                  </div>
                  <div className="mt-3 text-sm text-[color:var(--ink-secondary)] group-hover:text-[color:var(--brg)] transition">
                    {m.caption}
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Previously Owned */}
      <section className="parchment border-t border-[color:var(--accent)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <Reveal>
            <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
              <div>
                <div className="eyebrow mb-3">No. 02</div>
                <h2 className="font-display text-4xl md:text-5xl tracking-tight">Previously Owned</h2>
              </div>
              <span className="text-sm text-[color:var(--ink-muted)]">{PREVIOUS.length} motor cars</span>
            </div>
          </Reveal>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {PREVIOUS.map((p, idx) => (
              <Reveal key={`prev-${idx}`} delay={(idx % 4) * 70}>
                <div data-testid={`previous-${idx}`} className="group">
                  <div className="tile aspect-[4/3]">
                    <img src={p.img} alt={p.caption} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="mt-3 text-sm text-[color:var(--ink-secondary)]">{p.caption}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
